/**
 * External dependencies
 */
import { useMemo } from 'react';
import { i18ns } from '@naruto/naruto-models/src/core/i18n';
import I18nManager from '@naruto/naruto-models/src/core/i18n/I18nManager';

/**
 * Internal dependencies
 */
import useMappedState from '@naruto/bgdcms/src/hooks/useMappedState';

export interface UseLang {
  i18ns: I18nManager;
}

/**
 * 描述 : 取得 翻譯檔 的 Class Instance
 */
export default function useLang(): UseLang {
  /* Global & Local State */
  const storeGlobal = useMappedState(state => state.global);

  /* Main */
  return useMemo(() => ({ i18ns }), [storeGlobal.globalLang]);
}
